import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternalRepatriationCreateFormDialog from './InternalRepatriationCreateFormDialog';

class InternalRepatriationCreateForm extends Component {
  render() {
    return (
      <div>
        <InternalRepatriationCreateFormDialog
          data={this.props.data}
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
        />
      </div>
    );
  }
}

InternalRepatriationCreateForm.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  data: PropTypes.shape({
    inbound: PropTypes.string,
    outbound: PropTypes.string,
  }).isRequired,
};

export default InternalRepatriationCreateForm;
